import { trans } from '@spotahome/soyuz/client';

export const canShowModal = rule =>
  rule?.landlordBirthday || rule?.landlordGender;

const LandlordLivesInHouseModal = ({ rule }) => {
  const bodyContent = [
    rule?.landlordBirthday ? (
      <p>
        <b>{trans('property.rule.feature.landlordLivesInHouse.birthdate')}</b>{' '}
        {rule?.landlordBirthday}
      </p>
    ) : null,
    rule?.landlordGender ? (
      <p>
        <b>{trans('property.rule.feature.landlordLivesInHouse.gender')}:</b>{' '}
        {trans(
          `property.rule.feature.landlordLivesInHouse.${rule?.landlordGender}`
        )}
      </p>
    ) : null
  ].filter(Boolean);

  return <div>{bodyContent}</div>;
};

export default LandlordLivesInHouseModal;
